var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintBucketAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33238 21.1693L4.25 10C4.25 5.71979 7.71979 2.25 12 2.25C16.2802 2.25 19.75 5.71979 19.75 10L18.6676 21.1693C18.5805 22.066 17.8268 22.75 16.9258 22.75H7.07416C6.17326 22.75 5.41955 22.066 5.33238 21.1693ZM18.2055 9.25C17.8349 6.15183 15.198 3.75 12 3.75C8.80204 3.75 6.16506 6.15183 5.79454 9.25H8V11C8 11.5523 8.44772 12 9 12C9.55228 12 10 11.5523 10 11V9.25H12V10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10V12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12V9.25H18.2055ZM10 18.25C9.58579 18.25 9.25 18.5858 9.25 19C9.25 19.4142 9.58579 19.75 10 19.75H14C14.4142 19.75 14.75 19.4142 14.75 19C14.75 18.5858 14.4142 18.25 14 18.25H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBucketAlt);
export default __webpack_public_path__ + "static/media/paint-bucket-alt.39e61e6a9af707bfd3549b1347f8191e.svg";
export { ForwardRef as ReactComponent };